<template>
  <div class="main-section">
    <div class="chatbox">
      <div class="chatbox-content">
        <div class="left-select-chat">
          <el-card class="card-left-chatbox">
            <div class="left-chatbox-header">
              <div>
                <div class="header-content">
                  <p>SMS Chat</p>
                  <div class="box">
                    <el-tooltip class="item" effect="dark" content="New Message" placement="top">
                      <el-button @click="addNewChat = true" icon="el-icon-edit-outline"></el-button>
                    </el-tooltip>
                  </div>
                </div>
              </div>
            </div>
            <!-- eo left chatbox header -->

            <div class="chatbox-persons">
              <div v-if="loadingChatUsers == true" class="loading">
                <img src="~styles/img/load.gif" alt />
              </div>

              <ul v-if="loadingChatUsers == false" class="person-chat-details">
                <!-- <img src="~styles/img/user.png" alt="logo"> -->

                <li class="person-details" v-for="allConvoList in convoList" :key="allConvoList.id">
                  <a
                    v-if="allConvoList.name === null"
                    class="person-name"
                    :data-id="allConvoList.convo_id"
                    @click="changeChatUser(allConvoList.convo_id)"
                    :class="{ active: active_el == allConvoList.convo_id }"
                  >
                    <img
                      :data-id="allConvoList.convo_id"
                      class="user-image"
                      src="~styles/img/user.jpg"
                      alt
                    />
                    {{ allConvoList.convo_id }}
                  </a>

                  <a
                    v-else
                    class="person-name"
                    :data-id="allConvoList.convo_id"
                    @click="changeChatUser(allConvoList.convo_id)"
                    :class="{ active: active_el == allConvoList.convo_id }"
                  >
                    <img
                      :data-id="allConvoList.convo_id"
                      class="user-image"
                      src="~styles/img/user.jpg"
                      alt
                    />
                    {{ allConvoList.name }}
                    <span
                      :data-id="allConvoList.convo_id"
                    >| {{ allConvoList.convo_id }}</span>
                  </a>

                  <div class="contact-buttons">
                    <div class="box">
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="Add/Edit Contact"
                        placement="top"
                      >
                        <a
                          :data-id="allConvoList.user_id"
                          @click="editcontactdetailsbtn()"
                          class="add-detail el-icon-circle-plus-outline"
                        ></a>
                      </el-tooltip>
                    </div>
                    <!-- <div class="box">
                                    <el-tooltip
                                    class="item"
                                    effect="dark"
                                    content="Add/Edit information"
                                    placement="top">
                                        <a
                                        :data-id="allConvoList.user_id"
                                        @click="editcusform = true"
                                        class="add-detail el-icon-info"></a>
                                    </el-tooltip>
                    </div>-->
                  </div>
                </li>
              </ul>
            </div>
            <!-- eo chatbox-persons -->
          </el-card>
        </div>
        <!-- eo left select chat -->

        <div class="right-chat-box">
          <el-card class="card-right-chat-top">
            <div class="right-chatbox-header">
              <p v-if="currentActivename !== null">
                {{ currentActivename }}
                <span class="usernumber">{{ currentActiveId }}</span>
              </p>
              <p v-else>{{ currentActiveId }}</p>
            </div>
            <!-- eo right chatbox header -->

            <div class="main-chatbox">
              <div v-if="loadingChat == true" class="loading">
                <img src="~styles/img/load.gif" alt />
              </div>
              <div v-if="loadingChat == false" v-bind:class="{ noDisplay: isnoChat }">
                <div
                  class="chat-content"
                  v-for="convoChatlist in convoChat"
                  :key="convoChatlist.id"
                >
                  <div v-if="convoChatlist.from_user == '1'" class="chat-me">
                    <p class="name">
                      <span class="time">
                        {{
                        convoChatlist.datetime | date
                        }}
                      </span>
                      {{ myNumber }}
                    </p>

                    <div class="chat-box">
                      <p class="message">{{ convoChatlist.msg }}</p>
                    </div>

                    <p class="status">
                      {{ convoChatlist.client_user }}
                      <span
                        v-if="convoChatlist.delivery_status == '0'"
                        class="text-secondary el-icon-check"
                      ></span>
                      <span
                        v-if="convoChatlist.delivery_status == '1'"
                        class="text-success el-icon-check"
                      >
                        <i class="el-icon-check second-tick"></i>
                      </span>
                      <span
                        v-if="convoChatlist.delivery_status == '2'"
                        class="text-danger el-icon-close"
                      ></span>
                    </p>
                  </div>

                  <div v-else class="chat-you">
                    <p class="name">
                      {{ convoChatlist.from_user }}
                      <span class="time">
                        {{
                        convoChatlist.datetime | date
                        }}
                      </span>
                    </p>

                    <div class="chat-box">
                      <p class="message">{{ convoChatlist.msg }}</p>
                    </div>

                    <p class="status text-secondary" v-if="convoChatlist.delivery_status == '0'">
                      <span class="el-icon-check"></span>
                    </p>

                    <p class="status text-success" v-if="convoChatlist.delivery_status == '1'">
                      <span class="el-icon-check"></span>
                      <span class="el-icon-check second-tick"></span>
                    </p>

                    <p class="status text-danger" v-if="convoChatlist.delivery_status == '2'">
                      <span class="el-icon-close"></span>
                    </p>
                  </div>
                </div>
                <div class="auto-messages">
                  <ul>
                    <li
                      v-for="automessage in auto_message"
                      :key="automessage.id"
                      @click="setsmsm()"
                      :data-id="automessage.message"
                    >{{ automessage.message }}</li>
                  </ul>
                </div>
                <div class="no-chat-yet">
                  <img src="~styles/img/chat.svg" alt />
                  <p>No Chats Yet</p>
                </div>
              </div>
            </div>
            <!-- eo main chatbox -->
          </el-card>

          <el-card class="card-right-chat-bottom" v-bind:class="{ noDisplay: isnoChat }">
            <div class="chat-input" v-bind:class="{ noDisplay: isnoChat }">
              <div class="chat-input-box">
                <input
                  type="text"
                  class="chatbox-input"
                  placeholder="Type message"
                  v-model="sendReply.sendmsg"
                  v-on:keyup.enter="sendreplymsg()"
                />

                <button class="send-btn" @click="sendreplymsg()">
                  <img class="send-img" src="~styles/img/send.svg" alt />
                </button>
              </div>
            </div>
          </el-card>
        </div>
        <!-- eo right chat box -->
      </div>
      <!-- eo chatbox content -->
    </div>
    <!-- eo chat box -->

    <!-- dialog for new chat -->
    <el-dialog title="Send message" :visible.sync="addNewChat" width="50%">
      <form class="content-form">
        <div class="form-group">
          <label for>Number:</label>
          <input type="number" class="form-control" id v-model="newChatNumber" />
        </div>
        <div class="form-group">
          <label for>Message:</label>
          <textarea
            class="form-control message-text"
            rows="3"
            id="comment"
            v-model="newChatMessage"
            :maxlength="600"
            :minlength="10"
          ></textarea>
        </div>
      </form>

      <span slot="footer" class="dialog-footer" left>
        <el-button @click="addNewChat = false">Cancel</el-button>
        <el-button type="primary" @click="createNewChat()">Send</el-button>
      </span>
    </el-dialog>

    <!-- dialog for editing contact -->
    <el-dialog title="Edit Contact" :visible.sync="editContactdetails" width="50%">
      <div v-if="loadingEditContacts == true" class="loading">
        <img src="~styles/img/load.gif" alt />
      </div>

      <form v-if="loadingEditContacts == false" class="content-form">
        <div class="form-group">
          <label for>Name:</label>
          <input type="text" class="form-control" v-model="editContact.name" autofocus />
        </div>

        <div class="form-group">
          <label for>
            Number:
            <span class="text-info">(Please use country code)</span>
          </label>
          <input
            type="number"
            class="form-control"
            :minlength="10"
            :maxlength="14"
            v-model="editContact.number"
          />
        </div>

        <div class="form-group">
          <label for>code:</label>
          <input type="text" class="form-control" v-model="editContact.code" autofocus />
        </div>

        <div class="form-group">
          <label for>Age:</label>
          <input type="number" class="form-control" :maxlength="3" v-model="editContact.age" />
        </div>

        <div class="form-group">
          <label for>Gender:</label>
          <select class="form-control" v-model="editContact.gender">
            <option value>Select Gender</option>
            <option value="M">Male</option>
            <option value="F">Female</option>
            <option value="O">Other</option>
          </select>
        </div>

        <div class="form-group">
          <label for>Add to Group:</label>
          <el-checkbox-group class="select-group-here" v-model="editContact.groups">
            <el-checkbox
              v-for="groupDetaillist in groupDetail"
              :key="groupDetaillist.id"
              :label="groupDetaillist.id"
            >{{ groupDetaillist.group_name }}</el-checkbox>
          </el-checkbox-group>
        </div>

        <div class="form-group">
          <label for>details:</label>
          <textarea class="form-control message-text" rows="3" v-model="editContact.details"></textarea>
        </div>
      </form>

      <span slot="footer" class="dialog-footer" left>
        <el-button @click="editContactdetails = false">Cancel</el-button>
        <el-button type="primary" @click="saveEditedContact()">Save</el-button>
      </span>
    </el-dialog>

    <!-- dialog for Custom Forms -->
    <el-dialog title="Custom Forms" :visible.sync="editcusform" width="50%">
      <div class="forms-tab">
        <div class="custom-tabs">
          <ul>
            <li
              :data-id="formslist.id"
              v-for="formslist in customform_lists"
              :key="formslist.id"
            >{{ formslist.form_name }}</li>
          </ul>
        </div>

        <div class="custom-forms-details">
          <el-form
            class="content-form"
            :label-position="'top'"
            label-width="100%"
            v-for="cusformdetail in customform"
            :key="cusformdetail.id"
          >
            <div v-for="cusforms in cusformdetail.Form" :key="cusforms.id">
              <el-form-item v-if="cusforms.selectedtype == 'input'" :label="cusforms.title">
                <el-input v-model="cusforms.answer" autofocus></el-input>
              </el-form-item>

              <el-form-item v-if="cusforms.selectedtype == 'textarea'" :label="cusforms.title">
                <el-input type="textarea" :rows="4" v-model="cusforms.answer" autofocus></el-input>
              </el-form-item>

              <el-form-item v-if="cusforms.selectedtype == 'radio'" :label="cusforms.title">
                <el-radio-group v-model="cusforms.answer">
                  <el-radio
                    v-for="radiooption in cusforms.option"
                    :key="radiooption.id"
                    :label="radiooption.opt"
                  ></el-radio>
                </el-radio-group>
              </el-form-item>

              <el-form-item v-if="cusforms.selectedtype == 'checkbox'" :label="cusforms.title">
                <el-checkbox-group v-model="cusforms.answer">
                  <el-checkbox
                    v-for="checkboxoption in cusforms.option"
                    :key="checkboxoption.id"
                    :label="checkboxoption.opt"
                  ></el-checkbox>
                </el-checkbox-group>
              </el-form-item>

              <el-form-item v-if="cusforms.selectedtype == 'date'" :label="cusforms.title">
                <el-date-picker v-model="cusforms.answer" type="date"></el-date-picker>
              </el-form-item>

              <el-form-item v-if="cusforms.selectedtype == 'time'" :label="cusforms.title">
                <el-time-picker v-model="cusforms.answer"></el-time-picker>
              </el-form-item>
            </div>
          </el-form>
        </div>
      </div>

      <span slot="footer" class="dialog-footer" left>
        <el-button @click="addNewChat = false">Cancel</el-button>
        <el-button type="primary" @click="saveformdetail()">Send</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import {
  getusergroups,
  editgenericuser,
  getgenericuser,
  addNewContact,
  convolistUrl,
  sendreplyUrl,
  getmessagesUrl,
  getHeader
} from "./../../config";
import Vue from "vue";

export default {
  data() {
    return {
      loadingChatUsers: true,
      loadingChat: false,
      loadingEditContacts: true,

      auto_message: [
        { message: "Thank you so much." },
        { message: "We will solve the problem ASAP." }
      ],

      editcusform: false,
      editContactdetails: false,
      addContactdetails: false,
      isnoChat: false,
      addnewContact: false,
      active_el: 0,
      search: "",

      newChatNumber: "",
      newChatMessage: "",

      addNewChat: false,
      datetime: new Date(),
      myNumber: JSON.parse(window.sessionStorage.getItem("mycontact")),
      page: 1,
      currentActiveId: "",
      currentActivename: "",
      groupDetail: [
        {
          id: "",
          group_name: "",
          group_description: ""
        }
      ],
      convoList: {
        convo_id: [],
        dateTime: "",
        name: "",
        unread: "",
        user_id: ""
      },
      convoChat: {
        client_user: "",
        unread: "",
        from_user: "",
        convo_id: "",
        to_user: "",
        datetime: "",
        msg: "",
        delivery_status: ""
      },
      sendReply: {
        sendmsg: ""
      },
      editContact: {
        id: "",
        name: "",
        code: "",
        number: "",
        groups: [],
        age: "",
        gender: "",
        details: ""
      },

      customform_lists: [
        { id: "1", form_name: "form 001" },
        { id: "2", form_name: "form 002" },
        { id: "3", form_name: "form 003" }
      ],

      customform: [
        {
          id: "1",
          form_name: "This is form name",
          Form: [
            {
              title: "This is input",
              selectedtype: "input",
              option: "",
              answer: ""
            },
            {
              title: "This is textarea",
              selectedtype: "textarea",
              option: "",
              answer: ""
            },
            {
              title: "This is radio",
              selectedtype: "radio",
              option: [{ opt: "radio1" }, { opt: "radio2" }],
              answer: ""
            },
            {
              title: "This is checkbox",
              selectedtype: "checkbox",
              option: [{ opt: "checkbox1" }, { opt: "checkbox2" }],
              answer: []
            },
            {
              title: "this is for date",
              selectedtype: "date",
              option: "",
              answer: ""
            },
            {
              title: "this is for time",
              selectedtype: "time",
              option: "",
              answer: ""
            }
          ]
        }
      ]
    };
  },

  methods: {
    setsmsm() {
      this.sendReply.sendmsg = event.target.dataset.id;
    },

    refreshConvoListApi() {
      axios
        .post(convolistUrl, { page: 1 }, { headers: getHeader() })
        .then(Response => {
          this.convoList = Response.data.data;
        });
    },
    scrollToEnd() {
      const container = document.querySelector(".main-chatbox");
      const scrollHeight = container.scrollHeight;
      container.scrollTop = scrollHeight;
    },

    changeChatUser: function(el) {
      this.loadingChat = true;
      var data_id = event.target.dataset.id;
      // console.log(data_id);
      this.currentActiveId = data_id;
      this.active_el = el;
      // console.log(this.active_el)

      axios
        .post(
          getmessagesUrl,
          { page: 1, number: this.currentActiveId },
          { headers: getHeader() }
        )
        .then(Response => {
          // console.log(Response);
          this.convoChat = Response.data.data.reverse();
          this.currentActivename = Response.data.name;
          this.$nextTick(function() {
            this.loadingChat = false;
            this.$nextTick(function() {
              this.scrollToEnd();
            });
          });
        });

      this.sendReply.sendmsg = "";
    },

    sendreplymsg() {
      axios
        .post(
          sendreplyUrl,
          {
            to_number: this.currentActiveId,
            from_number: this.myNumber,
            sms_text: this.sendReply.sendmsg
          },
          { headers: getHeader() }
        )
        .then(Response => {
          // console.log(Response);

          this.convoChat.push({
            unread: "0",
            convo_id: this.currentActiveId,
            from_user: "1",
            to_user: this.currentActiveId,
            datetime: this.datetime,
            msg: this.sendReply.sendmsg,
            delivery_status: "0"
          });

          this.$nextTick(function() {
            this.scrollToEnd();
            this.sendReply.sendmsg = "";
          });
        });
    },

    createNewChat() {
      var current = this.newChatNumber;
      var valObj = this.convoList.filter(function(elem) {
        if (elem.convo_id == current) return elem.convo_id;
      });

      if (valObj.length > 0) {
        // console.log("contact exists yes")
        axios
          .post(
            sendreplyUrl,
            {
              to_number: this.newChatNumber,
              from_number: this.myNumber,
              sms_text: this.newChatMessage
            },
            { headers: getHeader() }
          )
          .then(Response => {
            // console.log(Response);

            this.refreshConvoListApi();

            this.isnoChat = false;
            this.active_el = Response.data.data.convo_id;
            this.currentActiveId = Response.data.data.convo_id;

            this.$nextTick(function() {
              axios
                .post(
                  getmessagesUrl,
                  { page: 1, number: this.currentActiveId },
                  { headers: getHeader() }
                )
                .then(Response => {
                  // console.log(Response);
                  this.convoChat = Response.data.data.reverse();
                  this.currentActivename = Response.data.name;
                  this.$nextTick(function() {
                    this.scrollToEnd();
                    this.newChatNumber = "";
                    this.newChatMessage = "";
                    this.sendReply.sendmsg = "";
                  });
                });
            });
          })
          .catch(function(error) {
            this.$notify({
              group: "foo",
              type: "error",
              title: "Error",
              text: "Something went wrong cant send message."
            });
          });
      } else {
        // console.log("contact exists no")
        axios
          .post(
            sendreplyUrl,
            {
              to_number: this.newChatNumber,
              from_number: this.myNumber,
              sms_text: this.newChatMessage
            },
            { headers: getHeader() }
          )
          .then(Response => {
            if (Response.data.error != "true") {
              // console.log("error sending message")
              // console.log(Response);

              this.refreshConvoListApi();

              // this.convoList.unshift({
              //     convo_id: this.newChatNumber,
              //     dateTime: this.datetime,
              //     name: null
              // })

              this.$nextTick(function() {
                this.isnoChat = false;
                this.active_el = Response.data.data.convo_id;
                this.currentActiveId = Response.data.data.convo_id;
              });

              this.$nextTick(function() {
                axios
                  .post(
                    getmessagesUrl,
                    { page: 1, number: this.currentActiveId },
                    { headers: getHeader() }
                  )
                  .then(Response => {
                    // console.log(Response);
                    this.convoChat = Response.data.data.reverse();
                    this.currentActivename = Response.data.name;
                    this.$nextTick(function() {
                      this.scrollToEnd();
                      this.newChatNumber = "";
                      this.newChatMessage = "";
                      this.sendReply.sendmsg = "";
                    });
                  });
              });
            } else {
              this.$notify({
                group: "foo",
                type: "error",
                title: "Error sending message",
                text: "Message or Number invalid"
              });
            }
          })
          .catch(function(error) {
            this.$notify({
              group: "foo",
              type: "error",
              title: "Error",
              text: "Something went wrong cant send message."
            });
          });
      }

      this.$nextTick(function() {
        this.addNewChat = false;
      });
    },

    resetEditContactForm() {
      this.editContact.id = "";
      this.editContact.name = "";
      this.editContact.number = "";
      this.editContact.age = "";
      this.editContact.gender = "";
      this.editContact.details = "";
      this.editContact.groups = [];
    },

    editcontactdetailsbtn() {
      // this.editContactdetails = true;
      this.loadingEditContacts = true;
      var clickedid = event.target.dataset.id;
      axios
        .post(getgenericuser, { user_id: clickedid }, { headers: getHeader() })
        .then(Response => {
          if (Response.data.error == "false") {
            this.loadingEditContacts = false;
            this.editContact = Response.data.data;
            this.editContactdetails = true;
          }
        });
    },

    saveEditedContact() {
      axios
        .patch(editgenericuser + this.editContact.id, this.editContact, {
          headers: getHeader()
        })
        .then(Response => {
          if (Response.data.error != "true") {
            this.refreshConvoListApi();
            this.active_el = this.currentActiveId;

            this.resetEditContactForm();

            this.$notify({
              group: "foo",
              type: "success",
              title: "Contact Saved",
              text: "Contact has been successfully added."
            });
          } else {
            this.$notify({
              group: "foo",
              type: "error",
              title: "Contact not Saved",
              text: "Contacts cant be saved"
            });
          }
          this.editContactdetails = false;
        })
        .catch(function(error) {
          console.log(error);
        });
    }
  },

  mounted() {
    const run = this;
    axios
      .post(convolistUrl, { page: 1 }, { headers: getHeader() })
      .then(Response => {
        this.convoList = Response.data.data;
        this.$nextTick(function() {
          this.loadingChatUsers = false;
        });
        this.currentActiveId = Response.data.data[0].convo_id;

        axios
          .post(
            getmessagesUrl,
            { page: 1, number: this.currentActiveId },
            { headers: getHeader() }
          )
          .then(Response => {
            // console.log(Response);
            this.convoChat = Response.data.data.reverse();
            this.currentActivename = Response.data.name;

            this.$nextTick(function() {
              this.scrollToEnd();
            });
          })

          .catch(function(error) {
            console.log(error);
          });
        this.$nextTick(function() {
          // $(".person-name").first().addClass("active");
          this.active_el = this.currentActiveId;
        });
      })
      .catch(function(error) {
        console.log(error);
        run.isnoChat = true;
      });

    this.$nextTick(function() {
      window.setInterval(() => {
        // this.sayhello()
        axios
          .post(
            getmessagesUrl,
            { page: 1, number: this.currentActiveId },
            { headers: getHeader() }
          )
          .then(Response => {
            // console.log(Response.data.unread);
            // this.convoChat = Response.data.data.reverse();
            if (Response.data.unread == 1) {
              // console.log("its 0");
              this.convoChat = Response.data.data.reverse();

              this.$nextTick(function() {
                this.scrollToEnd();
              });
            }
          })

          .catch(function(error) {
            console.log(error);
          });
      }, 10000);
    });

    axios.get(getusergroups, { headers: getHeader() }).then(Response => {
      // console.log(Response)
      this.groupDetail = Response.data.data;
    });
  },

  computed: {
    filteredChat: function() {
      return this.convoList.filter(allConvoList => {
        return allConvoList.convo_id.match(this.search);
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/views/conversation.vue